import { createApp } from 'vue'
import { defineStore } from 'pinia'
import VueNativeSock from 'vue-native-websocket-vue3'
import { getAccessToken, getTenantId } from '@/utils/auth'
import App from '@/App.vue'

// import { setupStore } from "@/store/pinia/store";

interface sendObjectFace {
  type: string
  content: string | string[]
}

interface SocketStore {
  // 连接状态
  isConnected: boolean
  // 消息内容
  messages: Recordable
  // 重新连接错误
  reconnectError: boolean
  // 心跳消息发送时间
  heartBeatInterval: number
  // 心跳定时器
  heartBeatTimer: number

  screenMessageList: sendObjectFace[]

  singleScreenList: sendObjectFace[]
}

// 链接URL
export async function LINK() {
  let url = ''
  // 域名截取 wss
  if (import.meta.env.MODE === 'development') { url = `wss://wx.chenlingkj.com.cn/infra/ws/?token=${getAccessToken()}&tenantId=${getTenantId()}` }
  else {
    url = `wss://${window.location.host
      }/infra/ws/?token=${getAccessToken()}&tenantId=${getTenantId()}`
  }

  return url
}
export function useVueNativeSockStore(app: any) {
  return defineStore({
    id: 'socket',
    state: (): SocketStore => ({
      // 连接状态
      isConnected: false,
      // 消息内容
      messages: {},
      // 重新连接错误
      reconnectError: false,
      // 心跳消息发送时间
      heartBeatInterval: 20000,
      // 心跳定时器
      heartBeatTimer: 0,
      screenMessageList: [],
      singleScreenList: [],
    }),
    actions: {
      // 连接打开
      SOCKET_ONOPEN(event: any) {
        console.log('successful websocket connection')
        app.config.globalProperties.$socket = event.currentTarget

        this.isConnected = true
        // 连接成功时启动定时发送心跳消息，避免被服务器断开连接
        this.heartBeatTimer = window.setInterval(() => {
          this.isConnected
            && app.config.globalProperties.$socket.send('ping')
        }, this.heartBeatInterval)
      },
      // 连接关闭
      SOCKET_ONCLOSE(event: any) {
        this.isConnected = false
        // 连接关闭时停掉心跳消息
        window.clearInterval(this.heartBeatTimer)
        this.heartBeatTimer = 0
        console.log(`连接已断开: ${new Date()}`)
        // console.log(event);
      },
      // 发生错误
      SOCKET_ONERROR(event: any) {
        useVueNativeSock()
        console.error(event)
      },
      // 收到服务端发送的消息
      SOCKET_ONMESSAGE(event: any) {
        // console.log('WebSocket Message:', event.data)
        this.messages = event

        /// / 处理当前数据
        // const newData = JSON.parse(event.data)
        /// / console.log('newData:', newData)
        /// / 如果type为device_operate_screen ，则数据为燃气户运营大屏
        // if (newData.type === 'device_operate_screen')
        //  this.screenMessageList.unshift(newData)

        /// / 如果type为 device_single_screen-send ，则数据为单个设备大屏
        // if (newData.type === 'device_single_screen')
        //  this.singleScreenList.unshift(newData)

        // this.messages = {
        //  screenMessageList: this.screenMessageList,
        //  singleScreenList: this.singleScreenList
        // }

        // this.messages.push(event.data)
      },
      // 自动重连
      SOCKET_RECONNECT(count: any) {
        console.info('消息系统重连中...', count)
      },
      // 重连错误
      SOCKET_RECONNECT_ERROR() {
        this.reconnectError = true
      },
    },
  })()
}

export async function useVueNativeSock() {
  const appUseVue = createApp(App)

  const piniaSocketStore = useVueNativeSockStore(appUseVue)
  const url = await LINK()

  // console.log('useVueNativeSock',url);

  appUseVue.use(VueNativeSock, url, {
    // 启用pinia集成 | enable pinia integration
    store: piniaSocketStore,
    // 数据发送/接收使用使用json
    format: 'string',
    // 开启手动调用 connect() 连接服务器
    connectManually: true,
    // 开启自动重连
    reconnection: true,
    // 尝试重连的次数
    reconnectionAttempts: 5,
    // 重连间隔时间
    reconnectionDelay: 3000,
  })
}

// Need to be used outside the setup
// export function useSocketStoreWithOut(app: App<Element>) {
//  //setupStore(app);
//  return useSocketStore(app);
// }
